import User from '@/types/User';
import Project, {ProjectDef, ProjectFile, ProjectId} from '@/types/Project';
import Submission, {SubmissionDef, SubmissionId} from '@/types/Submission';
import SearchFilter from '@/types/SearchFilter';

export default abstract class Remote {
    // users
    public abstract login(): Promise<User>;
    public abstract logout(): Promise<void>;
    public abstract createFakeUser(email: string): Promise<UID>;
    public abstract deleteFakeUser(): Promise<void>;

    // project list
    public abstract userProjectList(uid: UID): Promise<ProjectDef[]>;

    // project
    public abstract createProject(projectInfo: Project): Promise<ProjectId>;
    public abstract deleteProject(projectId: ProjectId): Promise<void>;
    public abstract loadProject(projectId: ProjectId): Promise<Project>;
    public abstract updateProject(project: ProjectDef): Promise<void>;

    // files
    public abstract saveFile(uid: UID, projectId: ProjectId, file: ProjectFile): Promise<void>;
    public abstract updateFiles(uid: UID, projectId: ProjectId, filesToUpdate: ProjectFile[]): Promise<void[]>;
    public abstract listFiles(uid: UID, projectId: ProjectId): Promise<string[]>;
    public abstract deleteFiles(uid: UID, projectId: ProjectId, filesToDelete: string[]): Promise<void[]>;
    public abstract loadAllFiles(uid: UID, projectId: ProjectId): Promise<ProjectFile[]>;
    public abstract deleteAllFiles(uid: UID, projectId: ProjectId): Promise<void[]>;

    // submissions
    public abstract submitProject(submission: Submission, binaryFile: FileContent, previousSubmissionId?: SubmissionId): Promise<SubmissionId>;
    public abstract loadSubmission(submissionId: SubmissionId): Promise<[Submission, FileContent]>;
    public abstract searchSubmissions(filter: SearchFilter): Promise<SubmissionDef[]>;
    public abstract deleteSubmission(submissionId: SubmissionId): Promise<void>;
    public abstract upvoteSubmission(uid: UID, submissionId: SubmissionId): Promise<void>;
    public abstract downvoteSubmission(uid: UID, submissionId: SubmissionId): Promise<void>;
    public abstract listFavorites(uid: UID): Promise<SubmissionId[]>;

    // other
    public abstract close(): Promise<void>;
    public abstract debugState(): void;
    public abstract ensureEmptyDatabase(): Promise<void>;
}
